import HorizontalList from './HorizontalList';

export default HorizontalList;
